export default {
    props: {
        positionTop: {
            type: Number | String,
            kComposite: 'position.top'
        }, 
        positionLeft: {
            type: Number | String,
            kComposite: 'position.left'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/Position.js